module.exports = __webpack_public_path__ + "assets/Retina-Medium.87ae136546f1829642c68aa7d5bca0d4.woff2";